// extracted by mini-css-extract-plugin
export default {"radio-block-root":"RadioBlock_radio-block-root__t8hv1","group":"RadioBlock_group__OuTIj","toggle-col":"RadioBlock_toggle-col__2G-V1","label":"RadioBlock_label__uXO3z"};